import { QueryParameter } from '@/shared/constants/queryParams';
import { useShouldOpenPaymentWidget } from '@/shared/hooks/useShouldOpenPaymentWidget';
import { useIsPaymentManagerOpened } from '@/shared/hooks/useIsPaymentManagerOpened';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

export const useRestrictedForNotification = () => {
    const searchParams = useSearchParams();
    const shouldOpenWidgetFromQuery = useShouldOpenPaymentWidget();
    const isPaymentManagerVisible = useIsPaymentManagerOpened();
    const isWatch = searchParams.has(QueryParameter.WATCH);

    return isWatch || shouldOpenWidgetFromQuery || isPaymentManagerVisible;
};
